import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {backgroundColor, flexAbsoluteCenter, onDesktop} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";
import {useUserDevice} from "@pg-mono/user-device";

import {PropertyLocationGeneralAttributeBox} from "./PropertyLocationGeneralAttributeBox";

interface IProps {
    isMiddle?: boolean | null;
}

export const PropertyLocationBetweenOtherProperties = (props: IProps) => {
    const theme = useTheme();

    const isMobile = useUserDevice();
    const iconSize = isMobile ? "3" : "3.6";

    const description = props.isMiddle
        ? "Mieszkanie położone jest pomiędzy innymi nieruchomościami co zapewnia lepszą wydajność energetyczną."
        : "Mieszkanie położone jest na skraju budynku co zapewnia większe poczucie prywatności.";

    return (
        <PropertyLocationGeneralAttributeBox
            graphic={
                <div css={propertyHorizontalLocation}>
                    <div css={[propertyHorizontalLocationBox, !props.isMiddle && backgroundColor(theme.colors.primary)]}>
                        {!props.isMiddle && <CloseIcon size={iconSize} />}
                    </div>
                    <div css={[propertyHorizontalLocationBox, props.isMiddle && backgroundColor(theme.colors.primary)]}>
                        {props.isMiddle && <CloseIcon size={iconSize} />}
                    </div>
                    <div css={propertyHorizontalLocationBox} />
                </div>
            }
            title={props.isMiddle ? "Środkowe położenie mieszkania" : "Skrajne położenie mieszkania"}
            description={description}
        />
    );
};

const propertyHorizontalLocation = (theme: Theme) => css`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    background-color: ${theme.colors.secondary};
    border: 2px solid ${theme.colors.secondary};
    gap: 2px;
`;

const propertyHorizontalLocationBox = (theme: Theme) => css`
    width: 3.8rem;
    height: 3.8rem;
    ${flexAbsoluteCenter};
    background-color: ${theme.colors.gray[200]};

    ${onDesktop(css`
        width: 4.8rem;
        height: 4.8rem;
    `)};
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {backgroundColor, flexAbsoluteCenter, onDesktop} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";
import {useUserDevice} from "@pg-mono/user-device";

import {PropertyLocationGeneralAttributeBox} from "./PropertyLocationGeneralAttributeBox";

interface IProps {
    isMiddle?: boolean | null;
}

export const PropertyLocationBetweenOtherProperties = (props: IProps) => {
    const theme = useTheme();

    const isMobile = useUserDevice();
    const iconSize = isMobile ? "3" : "3.6";

    const description = props.isMiddle
        ? "Mieszkanie położone jest pomiędzy innymi nieruchomościami co zapewnia lepszą wydajność energetyczną."
        : "Mieszkanie położone jest na skraju budynku co zapewnia większe poczucie prywatności.";

    return (
        <PropertyLocationGeneralAttributeBox
            graphic={
                <div css={propertyHorizontalLocation}>
                    <div css={[propertyHorizontalLocationBox, !props.isMiddle && backgroundColor(theme.colors.primary)]}>
                        {!props.isMiddle && <CloseIcon size={iconSize} />}
                    </div>
                    <div css={[propertyHorizontalLocationBox, props.isMiddle && backgroundColor(theme.colors.primary)]}>
                        {props.isMiddle && <CloseIcon size={iconSize} />}
                    </div>
                    <div css={propertyHorizontalLocationBox} />
                </div>
            }
            title={props.isMiddle ? "Środkowe położenie mieszkania" : "Skrajne położenie mieszkania"}
            description={description}
        />
    );
};

const propertyHorizontalLocation = (theme: Theme) => css`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    background-color: ${theme.colors.secondary};
    border: 2px solid ${theme.colors.secondary};
    gap: 2px;
`;

const propertyHorizontalLocationBox = (theme: Theme) => css`
    width: 3.8rem;
    height: 3.8rem;
    ${flexAbsoluteCenter};
    background-color: ${theme.colors.gray[200]};

    ${onDesktop(css`
        width: 4.8rem;
        height: 4.8rem;
    `)};
`;
